import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";

import { ToastContainer } from "react-toastify";


const LoginPage = lazy(() => import("../../Pages/Login"));


const LoginMain = () => {

    

    return (
        <Fragment>

            {/* Login */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/" component={LoginPage}/>
            </Suspense>


            {/* <Route exact path="/" render={() => (
                <Redirect to="/login"/>
            )}/> */}
            <ToastContainer/>
        </Fragment>
    )
};

export default LoginMain;